import { createStyles, makeStyles } from '@mui/styles';

import {
    ColorPrimaryTextos, ColorSecundarioTextos, ColorFondoPrimario,
    ColorIconoTabsActivas, ColorBGTabsActivas, ColorIconoTabsInactivas, ColorBGTabsInactivas,
    ColorBotonPrimario, ColorLetraBotonPrimario, ColorBotonSecundario, ColorLetraBotonSecundario
} from '../Tool/PaletaColores';

import BannerBackGround from '../../Activos/Imagenes/BannerHome/BannerLateral.png';

export const StyleApp = {
    DivAppGeneral: {
        height: 'calc(100vh - 50px)',
        overflow: 'auto',
        display: "flex",
        flexWrap: 'nowrap'
    }
};

export const styleBarMovil = makeStyles((theme) =>
    createStyles({
        grow: {
            flexGrow: 1,
        }
    }));

export const styleComponent = {
    IconButton: {
        height: 47,
        width: 47,
        backgroundColor: '#EDF0F4',
        border: 'solid 1px'
    },
    Icon: {
        color: '#4A606C',
        fontSize: 'normal'
    },
};

export const modalesMensajesGenericos = {
    BotonesOk: {
        backgroundColor: ColorBotonPrimario,
        color: ColorLetraBotonPrimario,
        border: "0px"
    },
    BotonesNo: {
        backgroundColor: ColorBotonSecundario,
        color: ColorLetraBotonSecundario,
        border: "0px",
        marginRight: "15px"
    },
    CuerpoModal: {
        backgroundColor: ColorFondoPrimario,
        color: ColorSecundarioTextos
    }
}

export const styleTable = {
    TableHeader: {
        backgroundColor: '#F6F8FB'
    },
    Header: {
        textAlign: "left",
        color: '#8C95A7',
        border: "solid #E9EBEE 1px",
        padding: "8px 16px",
        height: "38px"
    },
    HeaderCenter: {
        textAlign: "center",
        color: '#8C95A7',
        border: "solid #E9EBEE 1px",
        padding: "8px 16px",
        height: "38px"
    },
    HeaderRight: {
        textAlign: "right",
        color: '#8C95A7',
        border: "solid #E9EBEE 1px",
        padding: "8px 16px",
        height: "38px"
    },
    Body: {
        padding: "8px 16px",
        textAlign: "left",
        border: "solid #E9EBEE 1px",
        height: "38px"
    },
    BodyRight: {
        padding: "8px 16px",
        textAlign: "right",
        border: "solid #E9EBEE 1px",
        height: "38px"
    },
    BodyCenter: {
        padding: "8px 16px",
        textAlign: "center",
        border: "solid #E9EBEE 1px",
        height: "38px"
    },
    BodyContainerButtoms: {
        display: 'inline-flex',
        justifyContent: "center",
        width: "100%"
    },
    BodyButtoms: {
        color: '#8C95A7',
        fontSize: 'larger'
    },
    BodyButtomSearch: {
        color: '#8C95A7',
        fontSize: 'larger',
        border: 'solid 1px'
    },
    BodyEditables: {
        padding: '9px !important',
        maxHeight: '15px !important'
    },
    TableConteiner: {
        width: 'auto',
        margin: 0,
        maxHeight: "500px"
    },
    TableConteinerStaticHeader: {
        width: 'auto',
        margin: 0,
        height: "350px"
    },
    CheckBoxTabla: {
        padding: '0px 9px'
    }
};

export const StyleNotFound = {
    Avatar: {
        margin: 5,
        backgroundColor: '#1976d2',
        width: 300,
        height: 300
    }
};

export const StyleBannerLateral = {
    Image: {
        height: '100%',
        width: 300,
        minWidth: 300,
        display: 'flex',
        // backgroundImage:
        //     `url(${BannerBackGround})`,
        // backgroundRepeat: "no-repeat",
        // backgroundSize: "cover",
        position: 'fixed',
        zIndex: 1000
    },
    Conteiner: {
        display: 'flex',
        alignItems: 'center',
        textAlign: 'center',
        flexDirection: 'column',
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        backdropFilter: 'blur(40px)',
        width: '100%',
        height: '100%'
    },
    LogoSvg: {
        padding: '40px 0px'
    },
    FontStyle: {
        maxWidth: 248,
        color: '#FFFFFF',
        fontWeight: 900,
        fontSize: 64,
        paddingBottom: 20
    },
    FloatFooterImage: {
        justifyContent: 'flex-start',
        position: 'absolute',
        bottom: '0%',
        left: '0%',
        bgcolor: 'transparent',
        overflow: 'visible',
        boderRadius: '0px',
        height: 'auto',
        width: 'auto',
        zIndex: -1
    },
    FooterImage: {
        height: '50%',
        width: '50%'
    },
    FooterImageRigth: {
        marginLeft: 'auto',
        marginTop: 'auto',
        marginRight: 20,
        marginBottom: 20,
    }
};

export const StyleHome = {
    Image: {
        width: '100%',
        display: 'flex',
        // background: 'rgb(30, 227, 207)',
        // background: 'linear-gradient(180deg, rgba(103, 103, 103, 1) 0%, rgba(246, 248, 251, 1) 30%)',
        padding: '20px 40px'
    },
    HeaderImageRigth: {
        zIndex: 1,
        justifyContent: 'flex-start',
        position: 'absolute',
        top: '0%',
        right: '0%',
        bgcolor: 'transparent',
        overflow: 'visible',
        boderRadius: '0px',
        height: 'auto',
        width: 'auto'
    },
    Card: {
        width: 'auto',
        margin: '20px 0px',
        padding: '0px 40px 20px',
        position: 'relative',
        zIndex: 2
    },
    ButtonClean: {
        color: ColorLetraBotonSecundario,
        backgroundColor: ColorBotonSecundario
    },
    ButtonSave: {
        color: ColorLetraBotonPrimario,
        backgroundColor: ColorBotonPrimario
    },
    ButtonText: {
        marginLeft: '-10px',
        marginRight: 'auto',
        color: 'rgb(25, 118, 210)',
        textTransform: 'none',
        textDecoration: 'underline',
        size: "normal",
        ':hover': {
            color: '#4284FF'
        }
    },
    GridConteiner: {
        padding: '0px 10px 0px 10px',
        width: 'auto',
        margin: 0,
        backgroundColor: '#FFFFFF'
    },
    GridItem: {
        padding: '8px 12px'
    },
    DivSalvarLimpiar: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        margin: "5px 23px",
        minHeight: '40px',
        paddingTop: '3px',
        paddingBottom: '3px'
    },
    textPrimary:{
        color:'#3F425D',
         fontWeight:700, 
         fontSize:"16px", 
         fontStyle:'normal'
    },
    textSecondary:{
        color:'#3F425D',
        fontWeight:400, 
        fontSize:"16px", 
        fontStyle:'normal'
    }
};

export const StyleHomeHeader = {
    DivConteiner: {
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        zIndex: 2
    },
    HeaderText: {
        marginLeft: 10,
        color: '#223354',
        fontWeight: 500,
        fontSize: 40,
    },
    EstadoText: {
        color: '#082478',
        fontWeight: 900,
        fontSize: 14,
    },
    IconHeader: {
        height: 64,
        width: 64
    },
    IconCircle: {
        color: '#082273',
        height: 32,
        width: 32
    },
    DivCircleContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        margin: 20
    },
    DivCircleIconContainer: {
        position: "relative",
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center"
    },
    DivCircleIconText: {
        position: "absolute",
        lineHeight: 1,
        color: "#fff",
        top: "0.5em",
        fontSize: "1em"
    }
};

export const StyleHomeFooter = {
    Button: {
        width: 150,
        color: '#3F425D',
        backgroundColor: '#1EE3CF',
        marginLeft: 10
    },
    Container: {
        marginTop: 'auto',
        marginLeft: 'auto',
        paddingBottom: 20
    }
};

export const styleToolBar = {
    IconButton: {
        marginLeft: '1rem',
        width: 36,
        height: 36,
        backgroundColor: '#EDF0F4'
    },
    Icon: {
        fontSize: 24,
        color: '#4A606C'
    }
};

export const styleButtonBar = makeStyles(() =>
    createStyles({
        Button: {
            padding: 0,
            marginLeft: '1rem !important',
            width: 60,
            height: 36
        },
        IconButton: {
            marginLeft: '1rem !important',
            width: 36,
            height: 36
        },
        Icon: {
            fontSize: 24
        },
        IconWhite: {
            fontSize: 24,
            color: '#FFFFFF'
        },
        Avatar: {
            width: 36,
            height: 36,
            fontSize: 24
        }
    }));

export default StyleApp;